import { File as FilePolyfill } from './File';
import { FileReader as FileReaderPolyfill } from './FileReader';

export { FilePolyfill as File, FileReaderPolyfill as FileReader };

// Export W3C spec compliant types
export type {
  BlobPart,
  FilePropertyBag,
  EventHandler,
  ProgressEvent,
  IFileReader,
  IFile,
  NodeFile,
  FileReaderState
} from './types';

// Polyfill globals if they don't exist
if (typeof global !== 'undefined') {
  if (!(global as any).FileReader) {
    (global as any).FileReader = FileReaderPolyfill;
  }
  if (!(global as any).File) {
    (global as any).File = FilePolyfill;
  }
}